// extracted by mini-css-extract-plugin
export var hidden = "_ua-0";